import { Globe } from "lucide-react";
import { languages } from "@/context/LanguageContext";

export default function LanguageToggleLink({ language, href, className = "" }) {
  if (!href) {
    return null;
  }

  const targetLanguage = language === "de" ? "en" : "de";
  const target = languages[targetLanguage];
  const codeLabel = target.code.toUpperCase();
  const label = target.flag && target.flag !== codeLabel ? `${target.flag} ${codeLabel}` : codeLabel;

  return (
    <a
      href={href}
      className={`flex items-center gap-2 px-3 py-1.5 rounded-full bg-zinc-800 hover:bg-zinc-700 text-zinc-300 text-sm transition-colors ${className}`.trim()}
      data-testid="language-toggle"
      hrefLang={targetLanguage}
      lang={targetLanguage}
    >
      <Globe className="w-4 h-4" />
      <span>{label}</span>
    </a>
  );
}
